import $ from 'jquery';

import GoogleAnalyticsUtils from 'chairisher/util/googleanalytics';

import { getAmplitudeEventPropertiesForProduct } from 'chairisher/analytics/product';
import { trackAddToCartForPRT } from 'chairisher/thirdparty/pinterestretargeting';
import {
    AmplitudeEventProperty,
    CheckoutPosition,
    logAmplitudeButtonClickEvent,
    logAmplitudeEvent,
    logAmplitudeLinkClickEvent,
} from 'chairisher/util/analytics';

/**
 * Tracks clicks on the mini cart "checkout" button
 */
export function trackCheckoutButton() {
    logAmplitudeButtonClickEvent('checkout', { [AmplitudeEventProperty.POSITION]: CheckoutPosition.MINI_CART });
}

/**
 * Tracks adding a product to the cart
 *
 * @param {ProductModel} product The product that is being added to the cart
 * @param {string=} position An optional string indicating the location of the add to cart click
 * @param {Object=} additionalAmplitudeProps An optional object containing additional Amplitude event properties
 */
export function trackAddToCart(product, position, additionalAmplitudeProps = {}) {
    const amplitudeProps = {
        ...getAmplitudeEventPropertiesForProduct(product),
        ...additionalAmplitudeProps,
    };
    if (position) {
        amplitudeProps[AmplitudeEventProperty.POSITION] = position;
    }
    logAmplitudeEvent('cart - add', amplitudeProps);

    GoogleAnalyticsUtils.logEvent('add_to_cart', {
        currency: 'USD',
        value: product.getPrice(),
        items: [
            {
                item_id: product.getId(),
                discount: product.getTradeDiscount(),
                price: product.getPrice(),
            },
        ],
    });

    trackAddToCartForPRT();
}

/**
 * Tracks removing a product from the cart
 *
 * @param {ProductModel} product The product that is being removed from the cart
 * @param {CheckoutPosition=} position Optional position to track where the removal happened
 */
export function trackRemoveFromCart(product, position = CheckoutPosition.CART) {
    logAmplitudeEvent('cart - remove', {
        'product id': product.getId(),
        'product taxonomy': product.getTaxonomy(),
        'position': position,
    });
}

/**
 * Tracks changes in cart item quantities
 *
 * @param {number} quantity
 * @param {ProductModel} productModel
 */
export function trackCartItemQuantity(quantity, productModel) {
    logAmplitudeEvent('cart item - quantity change', {
        [AmplitudeEventProperty.POSITION]: CheckoutPosition.MINI_CART,
        [AmplitudeEventProperty.QUANTITY]: quantity,
        [AmplitudeEventProperty.DEALER_GUID]: productModel.getDealerGuid(),
        [AmplitudeEventProperty.DISCOUNT_PERCENT]: productModel.getDiscountPercent(),
        [AmplitudeEventProperty.IS_MARKDOWN]: productModel.getIsMarkdown(),
        [AmplitudeEventProperty.IS_NEWLY_MADE]: productModel.getIsNewlyMade(),
        [AmplitudeEventProperty.IS_ON_PUBLIC_SALE]: productModel.getIsOnPublicSale(),
        [AmplitudeEventProperty.PRODUCT_ID]: productModel.getId(),
        [AmplitudeEventProperty.PRODUCT_PRICE]: productModel.getPrice(),
        [AmplitudeEventProperty.PRODUCT_TAXONOMY]: productModel.getTaxonomy(),
        [AmplitudeEventProperty.TRADE_DISCOUNT_PERCENT]: productModel.getTradeDiscount(),
    });
}

/**
 * Tracks when the buyer guarantee link is clicked on the MiniCart
 *
 * @param {Event} e
 */
export function trackBuyerGuarantee(e) {
    const $link = $(e.currentTarget);

    logAmplitudeLinkClickEvent('Buyer Guarantee', $link.attr('href'), CheckoutPosition.MINI_CART);
}
